export default [
	{
		path: "/check",
		name: "check",
		component: () => import( /* webpackChunkName: "activity" */ "../views/other/check.vue"),
		meta: {
			title: "学生信息",
			showloading: true,
			requiresAuth: false
		}
	}
]